import React from 'react';
import { Field } from 'formik';
import Fieldset from '../fieldset';

const InvoiceAdress = () => {
  return (
    <Fieldset heading="Rechnungsadresse">
      <Field
        name="customer_invoice_address.street"
        render={({ field }) => (
          <Fieldset.TextInput {...field} label="Straße" disabled />
        )}
      />
      <Field
        name="customer_invoice_address.zip"
        render={({ field }) => {
          return <Fieldset.TextInput {...field} label="PLZ" disabled />;
        }}
      />
      <Field
        name="customer_invoice_address.city"
        render={({ field }) => (
          <Fieldset.TextInput {...field} label="Stadt" disabled />
        )}
      />
      <Field
        name="customer_invoice_address.country"
        render={({ field }) => (
          <Fieldset.TextInput {...field} label="Land" disabled />
        )}
      />
    </Fieldset>
  );
};

export default InvoiceAdress;



// WEBPACK FOOTER //
// ../shop_main/components/orderformwizard/invoiceAddress.js